import gql from "graphql-tag";

export default gql`
	mutation startTrial($trialId: String!, $extension: JSONObject) {
		startTrial(trialId: $trialId, extension: $extension) {
			... on StartTrialSuccess {
				subscription {
					id
				}
				trialStatus
			}
			... on StartTrialFailure {
				errorCode
				message
			}
		}
	}
`;

export const readStartTrialResult = ({ data }) =>
	data && {
		...data.startTrial,
	};
